import React, { useContext } from 'react';
import { getContext } from 'common';
import { TreeContext } from './';
import Styled from './styles';

/** Internal component.  Used in Drop and Drag to place a 'line' where the dragged  item
 * will be dropped.
 * All other props will be provided to the wrapper element. */
const TreeDragLine = React.forwardRef<HTMLElement>((props, ref) => getContext(({ RTL }) => {
  const treeContext = useContext(TreeContext);
  return (
    <Styled.TreeDragWrapper RTL={RTL} ref={ref} {...props}>
      <Styled.TreeDragCircle $theme={treeContext.theme} />
      <Styled.TreeDragLine $theme={treeContext.theme} />
    </Styled.TreeDragWrapper>
  );
}));

TreeDragLine.displayName = 'TreeDragLine';

export default TreeDragLine;
